export enum TypeOfDrawerEnum {
  MODIFY = 'MODIFY',
  VIEW = 'VIEW',
  CREATE = 'CREATE',
  FILTER = 'FILTER',
  CLOSE = 'CLOSE',
  CUSTOM = 'CUSTOM',
}

export type TypeOfDrawer = keyof typeof TypeOfDrawerEnum;
